import { ref } from 'vue'

/** Whether the ☰ menu is out; one for the whole app, opened from whichever screen's title */
export const menuOpen = ref(false)
